export default __webpack_public_path__ + "static/media/chronicleDiagram.de268970.svg";